module.exports = __webpack_public_path__ + "static/TheMetSans-SemiboldItalic-cb722c4a07c89ac74976118d841310a8.woff2";